import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Fab, Switch, Checkbox, FormControlLabel, Slide } from "@material-ui/core";
import ExitIcon from '@material-ui/icons/Clear';
import React, { useEffect } from 'react';
import { Editor, EditorState } from "draft-js";
import "draft-js/dist/Draft.css";
import '../css/modal.css';
import { TransitionProps } from '@material-ui/core/transitions'

const Transition = React.forwardRef(function Transition(props: TransitionProps & { children?: React.ReactElement<any, any> },ref: React.Ref<unknown>,) { 
    return <Slide direction="left" ref={ref} {...props} />
})    

export type WhatsNewDialogProps = {
    title: string,
    message: string,
    handleClose: any,
    version: string,
    open: boolean,
}

export function WhatsNewDialog(props: WhatsNewDialogProps) {
    const [checked, setChecked] = React.useState<boolean>(false);    
    const [editorState, setEditorState] = React.useState(() => EditorState.createEmpty()); 

    
    const backdrop = {
        visible: { opacity: 1 },
        hidden: { opacity: 0 }
    }

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let { value } = event.target;
        console.log('checked: ' + event.target.checked);
        setChecked(event.target.checked);
    };      
    
    const handleClick = () => {
        // Passo al father il valore !!!
        props.handleClose(checked);
    }

    function createMarkup() {
        return {__html: props.message};
    }
    useEffect(() => {
        setEditorState(props.message);
    }, []);

    return (
        <Dialog
            open={props.open}
            onClose={props.handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="lg"
            TransitionComponent={Transition} 
            keepMounted={true} 
        >
            <DialogTitle id="alert-dialog-title" style={{textAlign: 'center'}}>{props.title}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <div dangerouslySetInnerHTML={createMarkup()} />        
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <div style={{verticalAlign: 'bottom'}}>
                        <label></label>
                        <FormControlLabel
                            control={<Checkbox checked={checked} onChange={handleChange} name="hide" color="primary"/>}
                            label="Non mostrare più"
                        />
                        &nbsp;
                        <ExitIcon style={{ height: '1.5rem', cursor: 'pointer', verticalAlign: 'middle'}}  color="primary" titleAccess="Chiudi" onClick={handleClick} />
                    </div>
                </DialogActions>
        </Dialog>
    )
}